// extracted by mini-css-extract-plugin
module.exports = {"item":"index_item_D0-ne","itemLink":"index_itemLink_3P4Yt","itemPic":"index_itemPic_1mthq","itemAction":"index_itemAction_17XD1"};